import type { LessonSession } from '@/components/ProgressCharts/types';

export interface SessionStats {
  totalSessions: number;
  passedSessions: number;
  passRate: number;
  averageAccuracy: number;
  averageTime: number;
  scheduleSessions: number;
  freePlaySessions: number;
}

export function calculateSessionStats(sessions: LessonSession[]): SessionStats | null {
  if (sessions.length === 0) return null;

  const totalSessions = sessions.length;
  const passedSessions = sessions.filter(s => s.passed).length;
  const totalAccuracy = sessions.reduce((sum, s) => sum + s.accuracy, 0) / totalSessions;
  const avgTime = sessions.reduce((sum, s) => sum + s.average_time, 0) / totalSessions;

  const scheduleSessions = sessions.filter(s => s.practice_mode === 'schedule');
  const freePlaySessions = sessions.filter(s => s.practice_mode === 'free_play');

  return {
    totalSessions,
    passedSessions,
    passRate: (passedSessions / totalSessions) * 100,
    averageAccuracy: totalAccuracy,
    averageTime: avgTime,
    scheduleSessions: scheduleSessions.length,
    freePlaySessions: freePlaySessions.length,
  };
}
